
function showHideSection() {
  const allSections = document.querySelectorAll(".voyage__solutions-listing--simple-grid-content-wrapper")
  Array.prototype.slice.call(allSections).forEach((section) => {
    let shouldWeHide = 0 
    const allCards = Array.prototype.slice.call(section.querySelectorAll("[data-grid-item]"))
    allCards.forEach(card => card.classList.contains("voyage__hidden") ? shouldWeHide++ : null)
    shouldWeHide < allCards.length ? section.classList.remove("voyage__hidden") : section.classList.add("voyage__hidden")
  })
}

const removeFilters = (currentMenuItem) => {
  const gridItems = Array.prototype.slice.call(document.querySelectorAll("[data-grid-item]"))
  const filterItems = Array.prototype.slice.call(document.querySelectorAll(".voyage__navigation-item"))

  if (currentMenuItem.dataset.tag && currentMenuItem.dataset.tag.toLowerCase() === 'all'){
    filterItems.forEach( menuItem => {
      if (menuItem.dataset.tag && menuItem.dataset.tag.toLowerCase() !== 'all' ) menuItem.dataset.selected = false 
    })
    gridItems.forEach( gridItem => {
      gridItem.classList.remove('voyage__hidden')
    })
  } else {
    filterItems.forEach( menuItem => {
      if (menuItem.dataset.tag && menuItem.dataset.tag.toLowerCase() === 'all') menuItem.dataset.selected = false 
    })

    const selectedFilters = filterItems.filter(selectedFilter => selectedFilter.dataset.selected === 'true')
    let dataTypes = []
    selectedFilters.forEach(itm => {
      if (itm.dataset.tag) {
        dataTypes.push(itm.dataset.tag.toLowerCase())
      }   
    })

    gridItems.forEach(gridItem => {
      const itemDataTags = gridItem.dataset.tags.toLowerCase().split(',')

      Array.prototype.findDatatype = function(arr) {
        return this.filter(function(e) {
          return arr.indexOf(e) > -1;
        });
      };
      
      const intersection = itemDataTags.findDatatype(dataTypes);

      if (intersection.length > 0){
        gridItem.classList.remove('voyage__hidden')
      } else {
        gridItem.classList.add('voyage__hidden')
      }

      // selectedFilters.forEach(selectedFilter => {
      //   if (gridItem.dataset.tags.toLowerCase().includes(selectedFilter.dataset.tag.toLowerCase())){
      //     gridItem.classList.remove('voyage__hidden')
      //   } else {
      //     gridItem.classList.add('voyage__hidden')
      //   }
      // })
    })
  }
  showHideSection()
}

const onClickFilter = (menuItem) => {
  if(menuItem.dataset.selected === "true" && menuItem.dataset.tag && menuItem.dataset.tag.toLowerCase() !== 'all'){
    menuItem.dataset.selected = false
  }else{
    menuItem.dataset.selected = true
  }
  removeFilters(menuItem);
  setDefaultFilter(menuItem);
}

function setDefaultFilter(menuItem) {
  var anySelected = menuItem.parentElement.querySelectorAll('[data-selected="true"]');
  if (!anySelected.length) {
    if(menuItem.parentElement.children.length) {
      if (menuItem.parentElement.children[0].dataset.tag === "all") {
        menuItem.parentElement.children[0].click();
      }
    }
  }
}

const addMenuItemClickEvents = (anchorMenu) => {
  if(!anchorMenu) {
    return;
  }
  
  Array.prototype.slice.call(anchorMenu).forEach(menuItem => {
    menuItem.addEventListener('click', () => { onClickFilter(menuItem) })
  })
}

export const addFilteringToAnchorMenuItems = () => {
  const anchorMenuInner = document.querySelectorAll('[data-anchor-menu] > a.voyage__navigation-item')

  addMenuItemClickEvents(anchorMenuInner)
}
